(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
const SELECTOR = '.collection-banner-new__select';

function initCollectionBannerSelect(select) {
  if (select.dataset.collectionBannerInitialized === 'true') return;

  const listbox = select.querySelector('.custom-select__listbox');

  if (listbox) {
    listbox.focus = function focusWithoutScroll() {
      HTMLElement.prototype.focus.call(this, { preventScroll: true });
    };
  }

  select.addEventListener('change', (event) => {
    const url = event.detail && event.detail.selectedValue;

    if (url) window.location.href = url;
  });

  select.dataset.collectionBannerInitialized = 'true';
}

function initCollectionBannerSelects(container = document) {
  customElements.whenDefined('custom-select').then(() => {
    container.querySelectorAll(SELECTOR).forEach(initCollectionBannerSelect);
  });
}

initCollectionBannerSelects();

document.addEventListener('shopify:section:load', (event) => {
  initCollectionBannerSelects(event.target);
});

},{}]},{},[1])

